import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const linkItemClasses =
    "text-gray-700 text-sm hover:text-blue-600 transition duration-150 block py-1";

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="bg-gray-100 border-t border-gray-300 pt-16 pb-6 mt-10 px-4 md:px-12 w-full">
      <div
        className="max-w-7xl mx-auto flex flex-wrap justify-between gap-8 md:gap-10 lg:gap-16"
      >
        {/* Discover Column */}
        <div
          className="w-1/2 sm:w-1/3 md:w-auto flex-1 min-w-[150px] lg:min-w-[180px]"
        >
          <h4
            className="text-lg font-bold mb-4 text-gray-900 uppercase tracking-wider"
          >
            Discover
          </h4>
          <ul className="list-none p-0 m-0 space-y-2">
            <li><Link to="/how-it-works" onClick={scrollToTop} className={linkItemClasses}>How it works</Link></li>
            <li><Link to="/business" onClick={scrollToTop} className={linkItemClasses}>Taskonnect for business</Link></li>
            <li><Link to="/earn-money" onClick={scrollToTop} className={linkItemClasses}>Earn money</Link></li>
            <li><Link to="/side-hustle" onClick={scrollToTop} className={linkItemClasses}>Side Hustle Calculator</Link></li>
            <li><Link to="/browse-tasks" onClick={scrollToTop} className={linkItemClasses}>Search jobs</Link></li>
            <li><Link to="/cost-guides" onClick={scrollToTop} className={linkItemClasses}>Cost Guides</Link></li>
            <li><Link to="/service-guides" onClick={scrollToTop} className={linkItemClasses}>Service Guides</Link></li>
            <li><Link to="/comparison-guides" onClick={scrollToTop} className={linkItemClasses}>Comparison Guides</Link></li>
            <li><Link to="/student-discount" onClick={scrollToTop} className={linkItemClasses}>Student Discount</Link></li>
            <li><Link to="/partners" onClick={scrollToTop} className={linkItemClasses}>Partners</Link></li>
            <li><Link to="/faq" onClick={scrollToTop} className={linkItemClasses}>New users FAQ</Link></li>
          </ul>
        </div>

        {/* Company Column */}
        <div className="w-1/2 sm:w-1/3 md:w-auto flex-1 min-w-[150px] lg:min-w-[180px]">
          <h4 className="text-lg font-bold mb-4 text-gray-900 uppercase tracking-wider">Company</h4>
          <ul className="list-none p-0 m-0 space-y-2">
            <li><Link to="/about" onClick={scrollToTop} className={linkItemClasses}>About us</Link></li>
            <li><Link to="/careers" onClick={scrollToTop} className={linkItemClasses}>Careers</Link></li>
            <li><Link to="/media" onClick={scrollToTop} className={linkItemClasses}>Media enquiries</Link></li>
            <li><Link to="/community-guidelines" onClick={scrollToTop} className={linkItemClasses}>Community Guidelines</Link></li>
            <li><Link to="/principles" onClick={scrollToTop} className={linkItemClasses}>Tasker Principles</Link></li>
            <li><Link to="/terms" onClick={scrollToTop} className={linkItemClasses}>Terms and Conditions</Link></li>
            <li><Link to="/blog" onClick={scrollToTop} className={linkItemClasses}>Blog</Link></li>
            <li><Link to="/support" onClick={scrollToTop} className={linkItemClasses}>Contact us</Link></li>
            <li><Link to="/privacy" onClick={scrollToTop} className={linkItemClasses}>Privacy policy</Link></li>
            <li><Link to="/investors" onClick={scrollToTop} className={linkItemClasses}>Investors</Link></li>
          </ul>
        </div>

        {/* Members Center Column */}
        <div className="w-1/2 sm:w-1/3 md:w-auto flex-1 min-w-[150px] lg:min-w-[180px]">
          <h4 className="text-lg font-bold mb-4 text-gray-900 uppercase tracking-wider">Members Center</h4>
          <ul className="list-none p-0 m-0 space-y-2">
            <li><Link to="/post-task" onClick={scrollToTop} className={linkItemClasses}>Post a task</Link></li>
            <li><Link to="/browse-tasks" onClick={scrollToTop} className={linkItemClasses}>Browse tasks</Link></li>
            <li><Link to="/auth" onClick={scrollToTop} className={linkItemClasses}>Login</Link></li>
            <li><Link to="/support" onClick={scrollToTop} className={linkItemClasses}>Support centre</Link></li>
          </ul>
        </div>

        {/* Popular Categories & Places */}
        <div className="w-full sm:w-1/2 md:w-auto flex space-x-8 min-w-[300px] lg:min-w-[360px]">
          {/* Popular Categories */}
          <div className="flex-1">
            <h4 className="text-lg font-bold mb-4 text-gray-900 uppercase tracking-wider">Popular Categories</h4>
            <ul className="list-none p-0 m-0 space-y-2">
              <li><Link to="/services?search=Cleaning" onClick={scrollToTop} className={linkItemClasses}>Cleaning</Link></li>
              <li><Link to="/services?search=Delivery" onClick={scrollToTop} className={linkItemClasses}>Delivery</Link></li>
              <li><Link to="/services?search=Handyman" onClick={scrollToTop} className={linkItemClasses}>Handyman</Link></li>
              <li><Link to="/services?search=Gardening" onClick={scrollToTop} className={linkItemClasses}>Gardening</Link></li>
            </ul>
          </div>

          {/* Popular Places */}
          <div className="flex-1">
            <h4 className="text-lg font-bold mb-4 text-gray-900 uppercase tracking-wider">Popular Places</h4>
            <ul className="list-none p-0 m-0 space-y-2">
              <li><Link to="/places/nairobi" onClick={scrollToTop} className={linkItemClasses}>Nairobi</Link></li>
              <li><Link to="/places/nakuru" onClick={scrollToTop} className={linkItemClasses}>Nakuru</Link></li>
              <li><Link to="/places/mombasa" onClick={scrollToTop} className={linkItemClasses}>Mombasa</Link></li>
              <li><Link to="/places/kiambu" onClick={scrollToTop} className={linkItemClasses}>Kiambu</Link></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom text-center mt-10 border-t border-gray-300 pt-6">
        <p className="text-xs md:text-sm text-gray-600">
          &copy; {new Date().getFullYear()} Taskonnect. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
